import React from 'react'

import styled from 'styled-components'

import i18n from 'live/services/i18n'

interface ImportDataErrors {
    data: any[]
}

export const ImportDataErrors = ({ data }: ImportDataErrors) => {
    return (
        <>
            {data.map((item, index) => (
                <ImportDataErrorsContainer key={index}>
                    {Object.keys(item).map(mapTypeKey => (
                        <ImportDataErrorsContent key={mapTypeKey}>
                            <MapTypeTitle>{mapTypeKey}:</MapTypeTitle>
                            {item[mapTypeKey].map((entityName, entityIndex) => (
                                <EntityContainer key={entityIndex}>
                                    {Object.keys(entityName).map(fieldName => {
                                        const isMappingError = fieldName === 'columnMappings-or-enumMappings'
                                        return (
                                            <div key={fieldName}>
                                                <EntityName>{fieldName}:</EntityName>
                                                {isMappingError ? (
                                                    <InvalidAttributeMessage>
                                                        {i18n('Invalid attribute')}
                                                    </InvalidAttributeMessage>
                                                ) : (
                                                    entityName[fieldName].map((field, fieldIndex) => (
                                                        <FieldContainer key={fieldIndex}>
                                                            <FieldName>{field.fieldName}:</FieldName>
                                                            <Message>{i18n(field.message)}</Message>
                                                        </FieldContainer>
                                                    ))
                                                )}
                                            </div>
                                        )
                                    })}
                                </EntityContainer>
                            ))}
                        </ImportDataErrorsContent>
                    ))}
                </ImportDataErrorsContainer>
            ))}
        </>
    )
}

const ImportDataErrorsContainer = styled.div``

const ImportDataErrorsContent = styled.div``

const MapTypeTitle = styled.div`
    font-weight: 700;
`

const EntityContainer = styled.div`
    margin-left: 20px;
`

const EntityName = styled.span`
    font-weight: 700;
`

const FieldContainer = styled.div`
    display: flex;
    align-items: start;
    gap: 4px;

    margin-left: 40px;
`

const FieldName = styled.span`
    font-weight: 700;
`

const Message = styled.span``

const InvalidAttributeMessage = styled.span`
    margin-left: 4px;
`
